import { InjectionToken } from '@angular/core';

export type Environment = {
  production: boolean;
  region: string;
  userPoolId: string;
  userPoolClientId: string;
  apiUrl: string;
  wssUrl: string;
};

export const ENVIRONMENT = new InjectionToken<Environment>('Environment');
